import { render, staticRenderFns } from "./RsaGestioneOspitiEditRichiestaEsameComponent.vue?vue&type=template&id=604ac3be"
import script from "./RsaGestioneOspitiEditRichiestaEsameComponent.vue?vue&type=script&lang=js"
export * from "./RsaGestioneOspitiEditRichiestaEsameComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports